import { gql } from "@apollo/client";

export const CREATE_EMAIL_SIGNUP = gql`
  mutation CreateEmailSignup(
    $contacted: Boolean
    $contactedBy: String
    $email: String!
    $notes: NotesInput
  ) {
    createEmailSignup(
      contacted: $contacted
      contactedBy: $contactedBy
      email: $email
      notes: $notes
    ) {
      id
      contacted
      contactedBy
      email
      notes {
        content
        timestamp
      }
    }
  }
`;
